import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { Toast } from 'primereact/toast';
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Navbar, Row, Form } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { BiLeftArrowAlt } from "react-icons/bi";
import { HiArrowLeft } from 'react-icons/hi';
import { MdOutlineCloudUpload } from 'react-icons/md';
import Loader from "react-js-loader";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Layout/Header";
import { getEndpointUrl, getTimestamp } from "../../Utils/Common";
import SidebarCategoryForm from './SidebarCategoryForm';
import { RadioButton } from "primereact/radiobutton";
import { classNames } from 'primereact/utils';
import Error404 from '../Error404';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const FormPemeriksaan = () => {
    const [error404, setError404] = useState(false);

    const [isLoading, setLoading] = useState(false);

    const [isSaveLoading, setSaveLoading] = useState(false);

    const toast = useRef(null);

    const params = useParams();

    const navigate = useNavigate();

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const [accesToken] = useState(JSON.parse(localStorage.getItem('credentials')) || []);

    const [item, setItem] = useState(null);

    const [gradeMesin, setGradeMesin] = useState(null);

    const [gradeExterior, setGradeExterior] = useState(null);

    const [gradeInterior, setGradeInterior] = useState(null);

    const methods = useForm({
        mode: "onSubmit"
    });

    const {
        register,
        control,
        handleSubmit,
        reset,
        formState: { errors }
    } = methods;

    const fetchDataItem = useCallback(async (item_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/inspeksi/${item_id !== undefined ? item_id : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setItem(json.results);

                let defaultValues = {};
                defaultValues.scanner = json.results.scanner;
                defaultValues.note = json.results.note;
                defaultValues.kesimpulan = json.results.kesimpulan;
                defaultValues.gradeMesin = json.results.gradeMesin;
                defaultValues.gradeExterior = json.results.gradeExterior;
                defaultValues.gradeInterior = json.results.gradeInterior;
                defaultValues.saranPerawatan = json.results.saranPerawatan;

                setGradeMesin(json.results.gradeMesin);
                setGradeExterior(json.results.gradeExterior);
                setGradeInterior(json.results.gradeInterior);

                reset({ ...defaultValues });
            } else {
                setError404(true);
            }

            setLoading(false);
        });
    }, []);

    useEffect(() => {
        fetchDataItem(params.item_id);
    }, [params]);

    const onCallback = useCallback((e) => {
        automaticSaveData(e);
    }, []);

    const automaticSaveData = async (data) => {
        setSaveLoading(data);
        await sleep(2000);
    };

    const onSubmit = (data) => {
        setSaveLoading(true);

        console.log("SEND IT",data)

        let formData = new FormData();    //formdata object

        formData.append('scanner', data.scanner);
        formData.append('note', data.note);
        formData.append('kesimpulan', data.kesimpulan);
        formData.append('gradeMesin', data.gradeMesin);
        formData.append('gradeExterior', data.gradeExterior);
        formData.append('gradeInterior', data.gradeInterior);
        formData.append('saranPerawatan', data.saranPerawatan);

        fetch(getEndpointUrl() + `/checkpoint/send_pemeriksaan/${params.item_id}`, {
            method: "POST",
            body: formData,
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                onCallback(json.results);

                toast.current.show({ severity: 'success', summary: 'Berhasil', detail: json.message });
            } else {
                toast.current.show({ severity: 'warn', summary: 'Gagal', detail: json.message });
            }
            setSaveLoading(false);
        }).catch(error => {
            setSaveLoading(false);
        });
    };

    return error404 ? <Error404 /> : (
        <>
            <Toast ref={toast} />
            <SidebarCategoryForm show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
            {isLoading ?
                <Container className="mt-5">
                    <div className="text-center mt-5">
                        <Loader type="bubble-scale" bgColor={"#EF9A9A"} size={100} />
                    </div>
                </Container> :
                <>
                    <Helmet>
                        <title>Hasil Pemeriksaan</title>
                    </Helmet>

                    <div className="d-block d-sm-none">
                        <Navbar expand="lg" className="mainNavbar border-bottom mb-3" fixed="top">
                            <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                                <HiArrowLeft />
                            </a>
                            <strong className="me-auto navTitle">Hasil Pemeriksaan <br />

                                {isSaveLoading ?
                                    <small className="text-muted fw-normal fst-italic">
                                        <FontAwesomeIcon icon={faSpinner} spin={true} /><small className="ms-2">Menyimpan...</small>
                                    </small> :
                                    <small className="text-muted fw-normal fst-italic">
                                        <MdOutlineCloudUpload /><small className="ms-2">Data tersimpan</small>
                                    </small>
                                }
                            </strong>
                            <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                        </Navbar>
                    </div>
                    <div className="d-none d-sm-inline">
                        <Header />
                    </div>
                    <FormProvider {...methods}>
                        <Form onSubmit={handleSubmit(onSubmit)} className="mb-5">
                            <Container className="mt-4 mb-5 pb-5">
                                <div className="d-none d-sm-inline">
                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <strong className="me-auto navTitle">Form Pemeriksaan</strong>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Button variant="secondary" onClick={() => navigate(-1)} className="pe-3"><BiLeftArrowAlt /> Kembali</Button>
                                        </Col>
                                        <Col>
                                            <div className="d-flex justify-content-end">
                                                {isSaveLoading ?
                                                    <div className="text-muted pt-2">
                                                        <FontAwesomeIcon icon={faSpinner} spin={true} /><small className="ms-2">Menyimpan...</small>
                                                    </div> :
                                                    <div className="text-muted pt-2">
                                                        <MdOutlineCloudUpload /><small className="ms-2">Data tersimpan</small>
                                                    </div>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="mt-5 pt-5">

                                    <Row className="mb-3">
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='fw-bold'>Hasil Scanner :</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    size='lg'
                                                    as={'textarea'}
                                                    rows={5}
                                                    autoComplete="off"
                                                    {...register("scanner", {
                                                        required: "Field wajib diisi!"
                                                    })}
                                                    isInvalid={errors.scanner ? true : false} />
                                                <Form.Text className="text-muted fs-13 clearfix">{errors.scanner?.message}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='fw-bold'>Catatan :</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    size='lg'
                                                    as={'textarea'}
                                                    rows={5}
                                                    autoComplete="off"
                                                    {...register("note", {
                                                        required: "Field wajib diisi!"
                                                    })}
                                                    isInvalid={errors.note ? true : false} />
                                                <Form.Text className="text-muted fs-13 clearfix">{errors.note?.message}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='fw-bold'>Kesimpulan :</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    size='lg'
                                                    as={'textarea'}
                                                    rows={5}
                                                    autoComplete="off"
                                                    {...register("kesimpulan", {
                                                        required: "Field wajib diisi!"
                                                    })}
                                                    isInvalid={errors.kesimpulan ? true : false} />
                                                <Form.Text className="text-muted fs-13 clearfix">{errors.kesimpulan?.message}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='fw-bold'>Grade Mesin :</Form.Label>
                                                <Controller
                                                    name={`gradeMesin`}
                                                    rules={{ required: "Field wajib diisi!" }}
                                                    render={({ field: { onChange, onBlur, value, ref } }) => (
                                                        <div className="d-flex flex-wrap gap-3">
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="a"
                                                                    value="A"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeMesin(e.value);
                                                                    }}
                                                                    checked={gradeMesin === 'A'}
                                                                    className={classNames({ 'p-invalid': errors.gradeMesin?.message })} />
                                                                <label htmlFor="a" className="ms-2">A</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="b"
                                                                    value="B"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeMesin(e.value);
                                                                    }}
                                                                    checked={gradeMesin === 'B'}
                                                                    className={classNames({ 'p-invalid': errors.gradeMesin?.message })} />
                                                                <label htmlFor="b" className="ms-2">B</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="cPlus"
                                                                    value="C+"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeMesin(e.value);
                                                                    }}
                                                                    checked={gradeMesin === 'C+'}
                                                                    className={classNames({ 'p-invalid': errors.gradeMesin?.message })} />
                                                                <label htmlFor="cPlus" className="ms-2">C+</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="c"
                                                                    value="C"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeMesin(e.value);
                                                                    }}
                                                                    checked={gradeMesin === 'C'}
                                                                    className={classNames({ 'p-invalid': errors.gradeMesin?.message })} />
                                                                <label htmlFor="c" className="ms-2">C</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="d"
                                                                    value="D"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeMesin(e.value);
                                                                    }}
                                                                    checked={gradeMesin === 'D'}
                                                                    className={classNames({ 'p-invalid': errors.gradeMesin?.message })} />
                                                                <label htmlFor="d" className="ms-2">D</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="e"
                                                                    value="E"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeMesin(e.value);
                                                                    }}
                                                                    checked={gradeMesin === 'E'}
                                                                    className={classNames({ 'p-invalid': errors.gradeMesin?.message })} />
                                                                <label htmlFor="e" className="ms-2">E</label>
                                                            </div>
                                                        </div>

                                                    )}
                                                />
                                                <Form.Text className="text-muted fs-13 clearfix">{errors.gradeMesin?.message}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='fw-bold'>Grade Exterior :</Form.Label>
                                                <Controller
                                                    name={`gradeExterior`}
                                                    rules={{ required: "Field wajib diisi!" }}
                                                    render={({ field: { onChange, onBlur, value, ref } }) => (
                                                        <div className="d-flex flex-wrap gap-3">
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeExterior-a"
                                                                    value="A"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeExterior(e.value);
                                                                    }}
                                                                    checked={gradeExterior === 'A'}
                                                                    className={classNames({ 'p-invalid': errors.gradeExterior?.message })} />
                                                                <label htmlFor="gradeExterior-a" className="ms-2">A</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeExterior-b"
                                                                    value="B"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeExterior(e.value);
                                                                    }}
                                                                    checked={gradeExterior === 'B'}
                                                                    className={classNames({ 'p-invalid': errors.gradeExterior?.message })} />
                                                                <label htmlFor="gradeExterior-b" className="ms-2">B</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeExterior-cPlus"
                                                                    value="C+"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeExterior(e.value);
                                                                    }}
                                                                    checked={gradeExterior === 'C+'}
                                                                    className={classNames({ 'p-invalid': errors.gradeExterior?.message })} />
                                                                <label htmlFor="gradeExterior-cPlus" className="ms-2">C+</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeExterior-c"
                                                                    value="C"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeExterior(e.value);
                                                                    }}
                                                                    checked={gradeExterior === 'C'}
                                                                    className={classNames({ 'p-invalid': errors.gradeExterior?.message })} />
                                                                <label htmlFor="gradeExterior-c" className="ms-2">C</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeExterior-d"
                                                                    value="D"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeExterior(e.value);
                                                                    }}
                                                                    checked={gradeExterior === 'D'}
                                                                    className={classNames({ 'p-invalid': errors.gradeExterior?.message })} />
                                                                <label htmlFor="gradeExterior-d" className="ms-2">D</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeExterior-e"
                                                                    value="E"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeExterior(e.value);
                                                                    }}
                                                                    checked={gradeExterior === 'E'}
                                                                    className={classNames({ 'p-invalid': errors.gradeExterior?.message })} />
                                                                <label htmlFor="gradeExterior-e" className="ms-2">E</label>
                                                            </div>
                                                        </div>

                                                    )}
                                                />
                                                <Form.Text className="text-muted fs-13 clearfix">{errors.gradeExterior?.message}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='fw-bold'>Grade Interior :</Form.Label>
                                                <Controller
                                                    name={`gradeInterior`}
                                                    rules={{ required: "Field wajib diisi!" }}
                                                    render={({ field: { onChange, onBlur, value, ref } }) => (
                                                        <div className="d-flex flex-wrap gap-3">
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeInterior-a"
                                                                    value="A"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeInterior(e.value);
                                                                    }}
                                                                    checked={gradeInterior === 'A'}
                                                                    className={classNames({ 'p-invalid': errors.gradeInterior?.message })} />
                                                                <label htmlFor="gradeInterior-a" className="ms-2">A</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeInterior-b"
                                                                    value="B"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeInterior(e.value);
                                                                    }}
                                                                    checked={gradeInterior === 'B'}
                                                                    className={classNames({ 'p-invalid': errors.gradeInterior?.message })} />
                                                                <label htmlFor="gradeInterior-b" className="ms-2">B</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeInterior-cPlus"
                                                                    value="C+"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeInterior(e.value);
                                                                    }}
                                                                    checked={gradeInterior === 'C+'}
                                                                    className={classNames({ 'p-invalid': errors.gradeInterior?.message })} />
                                                                <label htmlFor="gradeInterior-cPlus" className="ms-2">C+</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeInterior-c"
                                                                    value="C"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeInterior(e.value);
                                                                    }}
                                                                    checked={gradeInterior === 'C'}
                                                                    className={classNames({ 'p-invalid': errors.gradeInterior?.message })} />
                                                                <label htmlFor="gradeInterior-c" className="ms-2">C</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeInterior-d"
                                                                    value="D"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeInterior(e.value);
                                                                    }}
                                                                    checked={gradeInterior === 'D'}
                                                                    className={classNames({ 'p-invalid': errors.gradeInterior?.message })} />
                                                                <label htmlFor="gradeInterior-d" className="ms-2">D</label>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <RadioButton
                                                                    inputId="gradeInterior-e"
                                                                    value="E"
                                                                    onChange={(e) => {
                                                                        onChange(e.value);
                                                                        setGradeInterior(e.value);
                                                                    }}
                                                                    checked={gradeInterior === 'E'}
                                                                    className={classNames({ 'p-invalid': errors.gradeInterior?.message })} />
                                                                <label htmlFor="gradeInterior-e" className="ms-2">E</label>
                                                            </div>
                                                        </div>

                                                    )}
                                                />
                                                <Form.Text className="text-muted fs-13 clearfix">{errors.gradeInterior?.message}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label className='fw-bold'>Saran Perawatan :</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    size='lg'
                                                    as={'textarea'}
                                                    rows={5}
                                                    autoComplete="off"
                                                    {...register("saranPerawatan", {
                                                        required: "Field wajib diisi!"
                                                    })}
                                                    isInvalid={errors.saranPerawatan ? true : false} />
                                                <Form.Text className="text-muted fs-13 clearfix">{errors.saranPerawatan?.message}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            </Container>
                            <Navbar expand="lg" className="mainNavbar border-top" fixed="bottom">
                                <Container>
                                    <Link to={'#'} onClick={() => navigate(-1)} className="btn btn-outline-secondary"> <HiArrowLeft /> Kembali</Link>
                                    <Button variant="btn btn-success" type="submit" disabled={isLoading}>Simpan</Button>
                                </Container>
                            </Navbar>
                        </Form>
                    </FormProvider>

                </>
            }
        </>
    );
}

export default FormPemeriksaan;
